import React, { useState } from 'react'
import { styled, Box } from '@mui/material'
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(() => ({
    border: `none`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&::before': {
      display: 'none',
    },
  }));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }:any) => ({
  padding: theme.spacing(2)
}))

const CustomExpandIcon = () => {
  return (
    <Box
      sx={{
        ".Mui-expanded & > .collapsIconWrapper": {
          display: "none"
        },
        ".expandIconWrapper": {
          display: "none"
        },
        ".Mui-expanded & > .expandIconWrapper": {
          display: "block"
        }
      }}
    >
      <div className="expandIconWrapper">-</div>
      <div className="collapsIconWrapper">+</div>
    </Box>
  )
}

const FAQRenterItemComponent = () => {
  const [expanded, setExpanded] = useState<string | false>('panel1')

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false)
    }

  return (
    <>
      <div>
        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>What is Haystackers? Why should I rent with you?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Haystackers is one of the most affordable and safest peer to peer marketplaces EQUIPMENT rentals across the US. We treat our customers like family and believe in building relations and togetherness.
            </Typography>
            <Typography>
            Renting with us is hassle free and we make the rental process as stress free as possible. All you need to do is plan your farm project, and the rest is available at Haystackers.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>How to book an EQUIPMENT?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Booking an equipment is made very simple. From our catalogue of equipment, select the one that’s perfect for you using your location of pickup. After you decide on the equipment, send your request to the owners of the equipment with your desired dates of Usage. Your owner will reach out to you after the request is received. Once you both agree, you can make the payment on the platform to confirm the rental.
            </Typography>
          </AccordionDetails>
        </Accordion>
        
        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary aria-controls="panel3d-content" id="panel3d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>I have change of plans and need to cancel?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            In such scenarios you have 24 hours of “Change of Mind” duration in which Renter’s can cancel with no penalty. This is irrespective of the kind of cancellation policy and when you cancel. As long as you cancel within 24 hours from booking period you will get full refund(Minus Credit card transaction fee) no questions asked.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary aria-controls="panel4d-content" id="panel4d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>How do I send rental offer to an owner?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Select your preferred EQUIPMENT and send the offer to rent to the concerned owner and if accepted Booking is confirmed.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary aria-controls="panel5d-content" id="panel5d-header" expandIcon={<CustomExpandIcon />}>
          <Typography>How do I change dates in reservation?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Changing dates of a confirmed booking is only approved if Owner accepts the change. Change request has to be initiated by the renter and to be approved by the owner and vice versa for the changes to take place.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel6'}
          onChange={handleChange('panel6')}
        >
          <AccordionSummary aria-controls="panel6d-content" id="panel6d-header" expandIcon={<CustomExpandIcon />}>
          <Typography>Can I return the equipment on the weekend?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Absolutely. Based on your dates and your owner’s consent,  you can  return thequipmentNT even on weekends?.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel7'}
          onChange={handleChange('panel7')}
        >
          <AccordionSummary aria-controls="panel7d-content" id="panel7d-header" expandIcon={<CustomExpandIcon />}>
          <Typography>How are my refunds processed?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Based on the cancellation policy and when the cancellation was done Haystackers will calculate the refund and process it same day.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}

export default FAQRenterItemComponent
